import { useQuery } from '@tanstack/react-query';
import { workflowApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useWorkflowTemplates() {
  return useQuery({
    queryKey: queryKeys.workflows.templates(),
    queryFn: ({ signal }) =>
      workflowApiClient.getWorkflowTemplates(toCancelToken(signal)),
    staleTime: 60_000,
    meta: { errorContext: 'workflow templates' },
  });
}
